"use strict";

var _AsyncBoundary, _AsyncBoundary2, _AuthProvider;
import { ContactNumbersProvider, PageLoading } from '@autoguru/components';
import { Portal, StickyBox } from '@autoguru/overdrive';
import { AppAside, pageAsidePortalId } from '~/src/components/AppAside';
import { AppHeader, pageHeaderPortalId } from '~/src/components/AppHeader';
import { createEnvironment, EnvironmentProvider } from '@autoguru/relay';
import { getToken } from '@autoguru/auth/relay';
import { AuthProvider, createClient, withRequiredAuthentication } from '@autoguru/auth';
import { AsyncBoundary } from '@autoguru/suspense';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const relayModernEnvironment = createEnvironment({
  fetcherOptions: {
    getToken
  }
});
const authClient = createClient();
const AuthRequiredApp = withRequiredAuthentication(() => {
  return /*#__PURE__*/_jsx(EnvironmentProvider, {
    environment: relayModernEnvironment,
    children: /*#__PURE__*/_jsxs(ContactNumbersProvider, {
      children: [/*#__PURE__*/_jsx(Portal, {
        container: document.querySelector(`#${pageHeaderPortalId}`),
        children: _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
          fallback: PageLoading,
          children: /*#__PURE__*/_jsx(StickyBox, {
            top: "none",
            zIndex: 3,
            children: /*#__PURE__*/_jsx(AppHeader, {})
          })
        }))
      }), /*#__PURE__*/_jsx(Portal, {
        container: document.querySelector(`#${pageAsidePortalId}`),
        children: _AsyncBoundary2 || (_AsyncBoundary2 = /*#__PURE__*/_jsx(AsyncBoundary, {
          fallback: PageLoading,
          children: /*#__PURE__*/_jsx(AppAside, {})
        }))
      })]
    })
  });
});
export const App = () => _AuthProvider || (_AuthProvider = /*#__PURE__*/_jsx(AuthProvider, {
  allow_socials: true,
  optionalAuthentication: true,
  client: authClient,
  children: /*#__PURE__*/_jsx(AuthRequiredApp, {})
}));